import {FulfillmentType} from "@/data/entities/restaurant";
import {dinero, Dinero, EUR} from "dinero.js";

export const formatMoney = (amount: number): string => {
    const formatter = new Intl.NumberFormat("nl-NL", {
        style: "currency",
        currency: "EUR",
    });

    return formatter.format(amount);
};

type FulfillmentPricedItem = {
    price: string,
    priceTakeaway: string,
};

// type DepositPricedItem = {
//     deposit: string,
// };

// export const formatMoney = (inputString: string | number, withCurrencySymbol: boolean = false,): string =>
//     new Intl.NumberFormat(
//         "nl-NL",
//         withCurrencySymbol
//             ? {
//                 style: "currency",
//                 currency: "EUR",
//             }
//             : {
//                 minimumFractionDigits: 2,
//                 maximumFractionDigits: 2,
//             },
//     ).format(Number(inputString));

export const stringToDinero = (inputString: string): Dinero<number> =>
    dinero({amount: Math.round(Number(inputString) * 100), currency: EUR});

export const getProductPrice = (
    item: FulfillmentPricedItem,
    fulfillment: FulfillmentType,
): string =>
    fulfillment === "TAKEAWAY" ? item.priceTakeaway : item.price;

// export const getProductPriceForData = (
//     item: FulfillmentPricedItem,
//     fulfillment: FulfillmentType,
// ): string =>
//     "EUR " +
//     (fulfillment === "TAKEAWAY"
//         ? item.priceTakeaway
//         : item.price);

export const getFormattedProductPrice = (
    item: FulfillmentPricedItem,
    fulfillment: FulfillmentType,
): string =>
    fulfillment === "TAKEAWAY"
        ? formatMoney(Number(item.priceTakeaway))
        : formatMoney(Number(item.price));

// export const getFormattedDepositPrice = (
//     item: DepositPricedItem,
//     withCurrencySymbol: boolean = false,
// ): string =>
//     formatMoney(item.deposit, withCurrencySymbol);
